export interface ReferredUser {
    id: number;
    first_name: string;
    last_name: string;
}

export interface ReferralItem {
    id: number;
    date: string;
    status: ReferralStatus;
    referred_user: ReferredUser;
}

export interface ReferralProp {
    pending: ReferralItem[];
    expired: ReferralItem[];
    completed: ReferralItem[];
}

export enum ReferralStatus {
    PENDING = 0,
    ACCEPTED = 1,
    REJECTED = 2,
    ACCEPTED_WITH_NO_CREDS = 3,
}